import { gql } from "@apollo/client";

const LoginMutation = gql`
  mutation LeadMutation($fields: InputUser!) {
    lead(fields: $fields)
  }
`;

export default LoginMutation;
